import { FC } from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import clsx from 'clsx'
import CssBaseline from '@material-ui/core/CssBaseline'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import { Grid } from '@material-ui/core'
import Language from './language/language'

type LayoutPublicProps = {
    children: React.ReactNode
}
const LayoutPublic: FC<LayoutPublicProps> = ({ children }) => {
    const classes = useStyles()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <Grid container justify="space-between" alignContent="center">
                        <Grid item>
                            {/* <Grid container alignContent="center" justify="flex-start" style={{ height: '100%' }}> */}
                            {/* <Grid item xs={'auto'}> */}
                            <img
                                src={process.env.PUBLIC_URL + '/img/Chulalongkorn_University_Alt_Logo.svg.png'}
                                width="94"
                                height="34"
                                alt=""
                            />
                            {/* </Grid> */}
                            {/* </Grid> */}
                        </Grid>
                        <Grid item>
                            {/* <Grid
                                container
                                item
                                xs={true}
                                style={{ textAlign: 'end', minWidth: '350px', height: '100%' }}
                                alignContent="center"
                            > */}
                            {/* <Grid container item xs alignContent="center" justify="flex-end"> */}
                            {/* <Grid item xs={false}> */}
                            <Language />
                            {/* </Grid> */}
                            {/* </Grid> */}
                            {/* </Grid> */}
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>

            <main className={isMobileView ? classes.contentMobile : classes.content}>
                <div className={classes.drawerHeader} />
                <Grid container className={classes.containerBody}>
                    {children}
                </Grid>
            </main>
        </div>
    )
}
const useStyles = makeStyles((theme) => ({
    root: {
        // display: 'flex',
        backgroundImage: `url(${process.env.PUBLIC_URL + '/img/pink_bg.png'})`,
        // height: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
    },
    textPrimary: {
        color: theme.palette.text.primary,
    },
    appBar: {
        backgroundColor: 'white',
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    contentMobile: {
        backgroundColor: '#fff',
        padding: theme.spacing(3),
        width: '100%',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0),
        },
    },
    content: {
        flexGrow: 1,

        [theme.breakpoints.down(960)]: {
            backgroundColor: '#fff',
        },
        // padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    main: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '65px',
        width: '100%',
        // height: 'calc(100% - 65px)',
    },
    containerBody: {
        // flexGrow: 1,
        padding: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            // paddingLeft: '0px',
            // paddingRight: '0px',
            padding: '0px',
        },
        justifyContent: 'center',
        alignItems: 'center',
        // height: '1500px',
        // position: 'relative',
        // height: 'auto',
        // minHeight: '100% !important',
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // padding: (props: { isShowTab: boolean }) => {
        //     if (props.isShowTab) {
        //         return theme.spacing(7, 1)
        //     } else {
        //         return theme.spacing(0, 1)
        //     }
        // },
        [theme.breakpoints.down('md')]: {
            minHeight: '64px',
        },
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
}))

export default LayoutPublic
